export const AllSettingsRoutes = {
  index: "/settings",
  tenant_users: "/settings/tenant-users",
};
